import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import _Divider from 'reakit/Divider';
var contentProperties = css(["display:flex;align-items:center;justify-content:center;&::before{background:white;color:#c3c3c3;content:'", "';text-transform:uppercase;font-size:0.7em;font-weight:", ";padding:0.2rem 0.5rem;&{", "}}"], function (props) {
  return props.content;
}, theme('fannypack.fontWeights.bold'), theme('fannypack.Divider.content'));
var verticalProperties = css(["height:auto;&{", ";}"], theme('fannypack.Divider.vertical'));
var Divider = styled(_Divider).withConfig({
  displayName: "styled__Divider",
  componentId: "sc-1rdxdja-0"
})(["opacity:1;border-color:#e7e9ed;&{", ";", ";}&{", ";}"], function (props) {
  return props.content && contentProperties;
}, function (props) {
  return props.vertical && verticalProperties;
}, theme('fannypack.Divider.base'));
export default Divider;
export { Divider, contentProperties, verticalProperties };